var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2458 16.3067L10.6667 20.6667L13.7256 18.8313C13.8254 18.7715 13.8753 18.7416 13.9285 18.7299C13.9756 18.7195 14.0244 18.7195 14.0715 18.7299C14.1247 18.7416 14.1746 18.7715 14.2744 18.8313L17.3333 20.6667L16.7546 16.3048M16.9506 8.83263C17.0536 9.08164 17.2512 9.27957 17.5 9.38291L18.3726 9.74436C18.6216 9.84752 18.8195 10.0454 18.9226 10.2944C19.0258 10.5434 19.0258 10.8232 18.9226 11.0723L18.5615 11.9443C18.4583 12.1934 18.4581 12.4735 18.5618 12.7225L18.9223 13.5943C18.9735 13.7176 18.9998 13.8498 18.9998 13.9833C18.9998 14.1169 18.9736 14.2491 18.9225 14.3724C18.8714 14.4958 18.7965 14.6079 18.702 14.7023C18.6076 14.7967 18.4955 14.8716 18.3721 14.9226L17.5002 15.2838C17.2512 15.3868 17.0532 15.5844 16.9499 15.8333L16.5885 16.7059C16.4853 16.9549 16.2875 17.1528 16.0385 17.2559C15.7894 17.3591 15.5096 17.3591 15.2606 17.2559L14.3886 16.8947C14.1396 16.7918 13.8599 16.792 13.611 16.8953L12.7384 17.2563C12.4896 17.3592 12.21 17.3591 11.9612 17.256C11.7124 17.1529 11.5146 16.9553 11.4114 16.7066L11.0499 15.8337C10.9469 15.5847 10.7493 15.3867 10.5004 15.2834L9.62783 14.9219C9.37892 14.8188 9.18113 14.6211 9.07794 14.3722C8.97475 14.1233 8.97461 13.8436 9.07755 13.5946L9.43873 12.7226C9.54163 12.4736 9.54142 12.1939 9.43815 11.945L9.07749 11.0718C9.02635 10.9484 9.00002 10.8162 9 10.6827C8.99998 10.5492 9.02627 10.4169 9.07736 10.2936C9.12846 10.1702 9.20336 10.0582 9.29778 9.96375C9.39221 9.86935 9.50431 9.79448 9.62768 9.74343L10.4996 9.38223C10.7484 9.27936 10.9462 9.08197 11.0497 8.8334L11.4111 7.96078C11.5142 7.71175 11.7121 7.51389 11.9611 7.41074C12.2101 7.30759 12.4899 7.30759 12.739 7.41074L13.6109 7.77193C13.86 7.87483 14.1397 7.87462 14.3885 7.77135L15.2615 7.4113C15.5105 7.3082 15.7902 7.30823 16.0392 7.41136C16.2882 7.51449 16.486 7.71229 16.5892 7.96126L16.9507 8.83414L16.9506 8.83263Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSkills);
export default __webpack_public_path__ + "static/media/job-skills.1dddba6ecb16efdb38767b51d202e327.svg";
export { ForwardRef as ReactComponent };